import PropTypes from 'prop-types'
import { MonthRangeSelector } from '../../../common/components/MonthRangeSelector/MonthRangeSelector'

const DateRangeSelector = ({
  onGenerateReport,
  isLoading = false,
  showDownloadButton = false,
  onDownload,
  showPreviewButton = false,
  onPreview,
  isDownloading = false,
}) => (
  <MonthRangeSelector
    onSubmit={onGenerateReport}
    isLoading={isLoading}
    showDownloadButton={showDownloadButton}
    onDownload={onDownload}
    showPreviewButton={showPreviewButton}
    onPreview={onPreview}
    isDownloading={isDownloading}
    //onDowloadSinSiniestro={onDowloadSinSiniestro}
  />
)

DateRangeSelector.propTypes = {
  onGenerateReport: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  showDownloadButton: PropTypes.bool,
  onDownload: PropTypes.func,
  onDowloadSinSiniestro: PropTypes.func,
  showPreviewButton: PropTypes.bool,
  onPreview: PropTypes.func,
  isDownloading: PropTypes.bool,
}

export default DateRangeSelector
